exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading h4[data-v-74810004]{text-transform:uppercase;font-weight:500}[dir=ltr] .panel-heading h4[data-v-74810004]{margin-left:-20px;padding-left:10px}[dir=rtl] .panel-heading h4[data-v-74810004]{margin-right:-20px;padding-right:10px}.panel-flat[data-v-74810004]{overflow-x:hidden!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74810004","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/exportOrder/addExportOrder.vue
// module id = 944
// module chunks = 0